/*
  BPM store locator
  Data: Retailers metaobjects, rendered by sections/bpm-store-locator.liquid into a JSON block.
  Map: MapLibre GL JS + OpenFreeMap tiles (free, no key). Pins are HTML markers (vinyl records).
*/
(function () {
  'use strict';

  var CFG = window.BPMSL_CONFIG || {};
  var ML_VERSION = '5.24.0';
  var ML_JS = CFG.mlJs || 'https://cdn.jsdelivr.net/npm/maplibre-gl@' + ML_VERSION + '/dist/maplibre-gl.js';
  var ML_CSS = CFG.mlCss || 'https://cdn.jsdelivr.net/npm/maplibre-gl@' + ML_VERSION + '/dist/maplibre-gl.css';
  var ML_JS_SRI = 'sha384-5+cfbwT0iiub6VsQAdn6yz16nr6sDiQoHx6tm4O8OVYXHYOxcffFmCJBL0dgdvGp';
  var ML_CSS_SRI = 'sha384-uTttxo/aOKbdE5RlD/SPzSDoDmNvGlUYPjONi2MN/b7c9HPSvW07OIuyP7uL6jxK';
  var SOURCE = 'bpmsl-stores';
  // popup offsets per anchor so popups never cover the vinyl pin (pin is 50px tall, anchored at its tip)
  var POP_OFFSET = {
    'top': [0, 6], 'top-left': [6, 6], 'top-right': [-6, 6],
    'bottom': [0, -54], 'bottom-left': [6, -54], 'bottom-right': [-6, -54],
    'left': [22, -27], 'right': [-22, -27]
  };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // BPM palette
  var BRAND = { ink: '#231f20', ink2: '#414041', cream: '#f9f6f3', white: '#ffffff', orange: '#feb26c', lime: '#acb228', teal: '#228782', magenta: '#f157b7' };

  // Recolour the free OpenFreeMap "positron" basemap with BPM colours
  function brandStyle(map) {
    var style = map.getStyle() || {};
    (style.layers || []).forEach(function (l) {
      var id = l.id;
      function paint(prop, val) { try { map.setPaintProperty(id, prop, val); } catch (e) {} }
      if (l.type === 'background') { paint('background-color', BRAND.cream); return; }
      if (l.type === 'fill') {
        if (id === 'water') { paint('fill-color', BRAND.teal); paint('fill-opacity', 0.28); }
        else if (/park|wood/.test(id)) { paint('fill-color', BRAND.lime); paint('fill-opacity', 0.2); }
        else if (/ice|glacier/.test(id)) { paint('fill-color', BRAND.white); }
        else if (/residential/.test(id)) { paint('fill-color', BRAND.orange); paint('fill-opacity', 0.1); }
        else if (/building|aeroway/.test(id)) { paint('fill-color', BRAND.ink); paint('fill-opacity', 0.06); }
        else if (/pier/.test(id)) { paint('fill-color', BRAND.cream); }
        return;
      }
      if (l.type === 'line') {
        var c = null, o = null;
        if (/waterway/.test(id)) { c = BRAND.teal; o = 0.4; }
        else if (/boundary/.test(id)) { c = BRAND.magenta; o = 0.6; }
        else if (/dashline/.test(id)) { c = BRAND.cream; o = 1; }
        else if (/rail/.test(id)) { c = BRAND.ink; o = 0.2; }
        else if (/motorway/.test(id)) {
          if (/casing/.test(id)) { c = BRAND.ink; o = 0.15; }
          else { c = BRAND.orange; o = /tunnel|subtle/.test(id) ? 0.6 : 1; }
        }
        else if (/casing/.test(id)) { c = BRAND.ink; o = 0.12; }
        else if (/aeroway/.test(id)) { c = BRAND.ink; o = 0.1; }
        else if (/highway|road|pier/.test(id)) { c = BRAND.white; o = 1; }
        if (c) { paint('line-color', c); if (o != null) paint('line-opacity', o); }
        return;
      }
      if (l.type === 'symbol' && !/shield/.test(id)) {
        paint('text-color', /water/.test(id) ? BRAND.teal : BRAND.ink);
        paint('text-halo-color', BRAND.cream);
      }
    });
  }

  var PROVINCES = {
    AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador', NT: 'Northwest Territories', NS: 'Nova Scotia', NU: 'Nunavut',
    ON: 'Ontario', PE: 'Prince Edward Island', PEI: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon'
  };

  /* ---------- helpers ---------- */
  var mlPromise = null;
  function loadMapLibre() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (mlPromise) return mlPromise;
    mlPromise = new Promise(function (resolve, reject) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = ML_CSS;
      if (!CFG.mlCss) { css.integrity = ML_CSS_SRI; css.crossOrigin = 'anonymous'; }
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = ML_JS;
      s.async = true;
      if (!CFG.mlJs) { s.integrity = ML_JS_SRI; s.crossOrigin = 'anonymous'; }
      s.onload = function () { window.maplibregl ? resolve(window.maplibregl) : reject(new Error('MapLibre missing')); };
      s.onerror = function () { mlPromise = null; reject(new Error('MapLibre failed to load')); };
      document.head.appendChild(s);
    });
    return mlPromise;
  }

  var fsaCache = {};
  function loadFsa(url) {
    if (!fsaCache[url]) {
      fsaCache[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('FSA ' + r.status);
        return r.json();
      }).then(function (j) {
        var d = j.d || '', map = {};
        for (var i = 0; i + 12 <= d.length; i += 12) {
          map[d.substr(i, 3)] = { lat: parseInt(d.substr(i + 3, 4), 10) / 100, lng: -parseInt(d.substr(i + 7, 5), 10) / 100 };
        }
        return map;
      });
      fsaCache[url].catch(function () { delete fsaCache[url]; });
    }
    return fsaCache[url];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\bste?\.?\s/g, function (m) { return m.indexOf('ste') === 0 ? 'sainte ' : 'saint '; })
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function km(a, b) {
    var R = 6371, toR = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function fmtKm(d) {
    if (d < 1) return Math.max(50, Math.round(d * 1000 / 50) * 50) + ' m';
    if (d < 10) return d.toFixed(1) + ' km';
    return Math.round(d).toLocaleString('en-CA') + ' km';
  }

  /* ---------- vinyl record artwork ---------- */
  function discMarkup(cx, cy, r, labelR, spinClass, labelClass) {
    var g = '';
    var grooves = [0.84, 0.70, 0.56];
    g += '<g class="' + (spinClass || '') + '">';
    g += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + BRAND.ink + '"/>';
    for (var i = 0; i < grooves.length; i++) {
      g += '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r * grooves[i]).toFixed(2) + '" fill="none" stroke="' + BRAND.ink2 + '" stroke-width=".7"/>';
    }
    // shine wedge, makes the spin visible
    var a1 = -100 * Math.PI / 180, a2 = -40 * Math.PI / 180;
    g += '<path d="M' + cx + ' ' + cy + ' L' + (cx + r * Math.cos(a1)).toFixed(2) + ' ' + (cy + r * Math.sin(a1)).toFixed(2) +
      ' A' + r + ' ' + r + ' 0 0 1 ' + (cx + r * Math.cos(a2)).toFixed(2) + ' ' + (cy + r * Math.sin(a2)).toFixed(2) + ' Z" fill="#fff" opacity=".14"/>';
    g += '<circle class="' + (labelClass || 'bpmsl-label') + '" cx="' + cx + '" cy="' + cy + '" r="' + labelR + '"/>';
    g += '<circle cx="' + cx + '" cy="' + cy + '" r="' + Math.max(1.2, labelR * 0.2).toFixed(2) + '" fill="#fff"/>';
    g += '</g>';
    return g;
  }

  var PIN_SVG =
    '<svg class="bpmsl-pin__svg" viewBox="0 0 48 60" width="40" height="50" aria-hidden="true" focusable="false">' +
    '<path class="bpmsl-pin__body" d="M24 59 L7.2 36.6 A21 21 0 1 1 40.8 36.6 Z"/>' +
    discMarkup(24, 24, 17.5, 6.6, 'bpmsl-disc') +
    '</svg>';

  var CLUSTER_SVG =
    '<svg class="bpmsl-cluster__svg" viewBox="0 0 64 56" width="58" height="51" aria-hidden="true" focusable="false">' +
    '<circle cx="40" cy="22" r="20" fill="' + BRAND.ink + '" stroke="#ffffff" stroke-width="1.5"/>' +
    '<circle cx="40" cy="22" r="7.5" class="bpmsl-label--back"/>' +
    '<circle cx="26" cy="30" r="23.5" fill="#ffffff"/>' +
    discMarkup(26, 30, 22, 11.5, '', 'bpmsl-label--front') +
    '</svg>';

  var NOTE_SVG =
    '<svg viewBox="0 0 32 40" width="30" height="38" aria-hidden="true" focusable="false">' +
    '<g class="bpmsl-note__g">' +
    '<path d="M10 9 L26 4 L26 9.6 L10 14.6 Z"/>' +
    '<rect x="10" y="9" width="2.6" height="22"/>' +
    '<rect x="23.4" y="4.5" width="2.6" height="22"/>' +
    '<ellipse cx="7.4" cy="31" rx="5.2" ry="3.9" transform="rotate(-20 7.4 31)"/>' +
    '<ellipse cx="20.8" cy="26.5" rx="5.2" ry="3.9" transform="rotate(-20 20.8 26.5)"/>' +
    '</g></svg>';

  /* ---------- locator ---------- */
  function Locator(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-bpmsl-data]');
    var raw = [];
    try { raw = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { raw = []; }

    this.stores = [];
    this.byId = {};
    for (var i = 0; i < raw.length; i++) {
      var s = raw[i];
      var lat = parseFloat(s.lat), lng = parseFloat(s.lng);
      s.hasPin = isFinite(lat) && isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0);
      s.lat = lat; s.lng = lng;
      this.stores.push(s);
      this.byId[s.id] = s;
    }
    this.pinStores = this.stores.filter(function (x) { return x.hasPin; });

    this.listEl = root.querySelector('[data-list]');
    this.panel = root.querySelector('[data-panel]');
    this.mapEl = root.querySelector('[data-map]');
    this.mapMsg = root.querySelector('[data-map-msg]');
    this.statusEl = root.querySelector('[data-status]');
    this.showAllBtns = root.querySelectorAll('[data-show-all]');
    this.emptyEl = root.querySelector('[data-empty]');
    this.searchForm = root.querySelector('[data-search]');
    this.qInput = root.querySelector('[data-q]');
    this.provSelect = root.querySelector('[data-province]');
    this.nearBtn = root.querySelector('[data-near-me]');
    this.fsaUrl = root.getAttribute('data-fsa-url');
    this.styleName = root.getAttribute('data-map-style') || 'brand';

    this.items = {};
    var lis = root.querySelectorAll('.bpmsl-store');
    for (var j = 0; j < lis.length; j++) this.items[lis[j].getAttribute('data-id')] = lis[j];

    this.origin = null;
    this.originLabel = '';
    this.selectedId = null;
    this.hoverId = null;
    this.markers = {};
    this.onScreen = {};
    this.map = null;
    this.filterProv = '';

    if (!this.listEl) return;
    this.bindUi();
    this.refreshList();
    this.lazyInitMap();
  }

  Locator.prototype.bindUi = function () {
    var self = this;

    if (this.searchForm) {
      this.searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        self.search(self.qInput.value);
      });
    }
    if (this.nearBtn) {
      if (!('geolocation' in navigator)) this.nearBtn.hidden = true;
      this.nearBtn.addEventListener('click', function () { self.nearMe(); });
    }
    if (this.provSelect) {
      this.provSelect.addEventListener('change', function () {
        var v = self.provSelect.value;
        self.clearOrigin();
        self.closeSticky();
        self.deselect();
        if (!v) { self.showAll(); return; }
        self.fitStores(self.pinStores.filter(function (s) { return s.prov === v; }), 11);
      });
    }
    for (var i = 0; i < this.showAllBtns.length; i++) {
      this.showAllBtns[i].addEventListener('click', function () { self.showAll(); });
    }

    Object.keys(this.items).forEach(function (id) {
      var li = self.items[id];
      li.addEventListener('mouseenter', function () { self.setHover(id, true); });
      li.addEventListener('mouseleave', function () { self.setHover(id, false); });
      var btn = li.querySelector('[data-show-on-map]');
      if (btn) btn.addEventListener('click', function () { self.select(id, { fly: true, popup: true }); });
      var card = li.querySelector('.bpmsl-card');
      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        if (self.byId[id] && self.byId[id].hasPin) self.select(id, { fly: true, popup: true });
      });
    });
  };

  Locator.prototype.lazyInitMap = function () {
    var self = this;
    if (!this.mapEl) return;
    var start = function () { self.initMap(); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '300px' });
      io.observe(this.mapEl);
    } else {
      start();
    }
  };

  Locator.prototype.mapFailed = function (err) {
    if (window.console) console.warn('[BPM locator] map unavailable:', err && err.message ? err.message : err);
    this.root.classList.add('bpmsl--nomap');
    if (this.mapMsg) {
      this.mapMsg.hidden = false;
      this.mapMsg.textContent = 'The map could not load on this device. All stores are listed here.';
    }
    this.map = null;
    this.refreshList();
  };

  Locator.prototype.initMap = function () {
    var self = this;
    loadMapLibre().then(function (ml) {
      var brand = self.styleName === 'brand';
      var styleUrl = CFG.styleUrl || ('https://tiles.openfreemap.org/styles/' + (brand ? 'positron' : self.styleName));
      var map;
      try {
        map = new ml.Map({
          container: self.mapEl,
          style: styleUrl,
          center: [-79.38, 43.7],
          zoom: 9,
          minZoom: 2,
          maxZoom: 18,
          cooperativeGestures: true,
          dragRotate: false,
          pitchWithRotate: false,
          touchPitch: false,
          maxPitch: 0,
          attributionControl: { compact: true }
        });
      } catch (e) {
        self.mapFailed(e);
        return;
      }
      self.map = map;
      if (brand) map.once('style.load', function () { brandStyle(map); });
      map.touchZoomRotate.disableRotation();
      map.addControl(new ml.NavigationControl({ showCompass: false }), 'top-right');
      map.on('error', function (e) { if (window.console) console.warn('[BPM locator]', e && e.error ? e.error.message : e); });

      map.on('load', function () {
        if (self.mapMsg) self.mapMsg.hidden = true;
        map.addSource(SOURCE, {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: self.pinStores.map(function (s) {
              return { type: 'Feature', properties: { id: s.id }, geometry: { type: 'Point', coordinates: [s.lng, s.lat] } };
            })
          },
          cluster: true,
          clusterMaxZoom: 12,
          clusterRadius: 48
        });
        // invisible layer so the source is tiled and queryable
        map.addLayer({ id: 'bpmsl-anchor', type: 'circle', source: SOURCE, paint: { 'circle-radius': 0, 'circle-opacity': 0 } });

        map.on('render', function () {
          if (!map.getSource(SOURCE) || !map.isSourceLoaded(SOURCE)) return;
          self.updateMarkers();
        });
        map.on('moveend', function () { self.refreshList(); });

        self.fitStores(self.pinStores, 12, true);
        self.refreshList();
      });
    }).catch(function (e) { self.mapFailed(e); });
  };

  /* ---------- markers ---------- */
  Locator.prototype.makePin = function (id) {
    var self = this, s = this.byId[id];
    var wrap = el('div', 'bpmsl-marker');
    var btn = el('button', 'bpmsl-pin' + (s.tone === 'teal' ? ' bpmsl-pin--teal' : ''));
    btn.type = 'button';
    btn.setAttribute('aria-label', s.name + (s.addr ? ', ' + s.addr : ''));
    btn.innerHTML = PIN_SVG;
    wrap.appendChild(btn);
    btn.addEventListener('mouseenter', function () { self.setHover(id, true, true); });
    btn.addEventListener('mouseleave', function () { self.setHover(id, false, true); });
    btn.addEventListener('focus', function () { self.setHover(id, true, true); });
    btn.addEventListener('blur', function () { self.setHover(id, false, true); });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      self.select(id, { popup: true, scrollList: true });
    });
    if (id === this.selectedId) btn.classList.add('is-selected');
    var m = new window.maplibregl.Marker({ element: wrap, anchor: 'bottom' }).setLngLat([s.lng, s.lat]);
    m._bpmBtn = btn;
    return m;
  };

  Locator.prototype.makeCluster = function (props, coords) {
    var self = this;
    var count = props.point_count;
    var wrap = el('div', 'bpmsl-marker bpmsl-marker--cluster');
    var btn = el('button', 'bpmsl-cluster');
    btn.type = 'button';
    btn.setAttribute('aria-label', count + ' stores here. Zoom in');
    btn.innerHTML = CLUSTER_SVG;
    btn.appendChild(el('span', 'bpmsl-cluster__count', count > 99 ? '99+' : String(count)));
    wrap.appendChild(btn);
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var src = self.map.getSource(SOURCE);
      Promise.resolve(src.getClusterExpansionZoom(props.cluster_id)).then(function (z) {
        self.map.easeTo({ center: coords, zoom: Math.min(z + 0.5, 16), duration: reduceMotion ? 0 : 500 });
      });
    });
    return new window.maplibregl.Marker({ element: wrap, anchor: 'center' }).setLngLat(coords);
  };

  Locator.prototype.updateMarkers = function () {
    var feats = this.map.querySourceFeatures(SOURCE);
    var next = {};
    for (var i = 0; i < feats.length; i++) {
      var p = feats[i].properties || {};
      var key, m;
      if (p.cluster) {
        key = 'c' + p.cluster_id;
        m = this.markers[key] || (this.markers[key] = this.makeCluster(p, feats[i].geometry.coordinates.slice()));
      } else {
        if (!this.byId[p.id]) continue;
        key = 's' + p.id;
        m = this.markers[key] || (this.markers[key] = this.makePin(p.id));
      }
      next[key] = m;
      if (!this.onScreen[key]) m.addTo(this.map);
    }
    for (var k in this.onScreen) {
      if (!next[k]) this.onScreen[k].remove();
    }
    this.onScreen = next;
  };

  Locator.prototype.pinBtn = function (id) {
    var m = this.markers['s' + id];
    return m ? m._bpmBtn : null;
  };

  /* ---------- hover and select ---------- */
  Locator.prototype.setHover = function (id, on, fromMap) {
    var li = this.items[id];
    var btn = this.pinBtn(id);
    if (on) {
      this.hoverId = id;
      if (li) li.classList.add('is-hover');
      if (btn) btn.classList.add('is-hover');
      if (fromMap && id !== this.selectedId) this.showPopup(id, false);
    } else {
      if (this.hoverId === id) this.hoverId = null;
      if (li) li.classList.remove('is-hover');
      if (btn) btn.classList.remove('is-hover');
      if (fromMap && this.hoverPopup && id !== this.selectedId) { this.hoverPopup.remove(); this.hoverPopup = null; }
    }
  };

  Locator.prototype.popupNode = function (s, sticky) {
    var self = this;
    var box = el('div', 'bpmsl-pop');
    var head = el('div', 'bpmsl-pop__head');
    var logo = el('div', 'bpmsl-logo bpmsl-logo--sm');
    if (s.logo) {
      var img = el('img', 'bpmsl-logo__img');
      img.src = s.logo; img.alt = ''; img.width = 40; img.height = 40;
      logo.appendChild(img);
    } else {
      var v = el('span', 'bpmsl-logo__vinyl' + (s.tone === 'teal' ? ' bpmsl-logo__vinyl--teal' : ''));
      v.appendChild(el('span', null, s.ini || ''));
      logo.appendChild(v);
    }
    head.appendChild(logo);
    var t = el('div', 'bpmsl-pop__title');
    t.appendChild(el('strong', null, s.name));
    if (s.type) t.appendChild(el('span', 'bpmsl-pop__type', s.type));
    head.appendChild(t);
    box.appendChild(head);
    if (s.addr) box.appendChild(el('p', 'bpmsl-pop__addr', s.addr));
    if (s.testers) box.appendChild(el('span', 'bpmsl-badge', 'Testers in store'));
    if (this.origin) box.appendChild(el('p', 'bpmsl-pop__dist', fmtKm(km(this.origin, s)) + ' away'));
    if (sticky) {
      var row = el('div', 'bpmsl-pop__actions');
      var dir = el('a', 'bpmsl-textbtn', 'Directions');
      dir.href = s.dir; dir.target = '_blank'; dir.rel = 'noopener';
      row.appendChild(dir);
      if (s.tel) {
        var call = el('a', 'bpmsl-textbtn', 'Call');
        call.href = 'tel:' + s.tel;
        row.appendChild(call);
      }
      var more = el('button', 'bpmsl-textbtn', 'Details');
      more.type = 'button';
      more.addEventListener('click', function () { self.scrollToItem(s.id, true); });
      row.appendChild(more);
      box.appendChild(row);
    }
    return box;
  };

  Locator.prototype.showPopup = function (id, sticky) {
    if (!this.map) return;
    var s = this.byId[id];
    if (!s || !s.hasPin) return;
    var ml = window.maplibregl;
    if (sticky) {
      if (this.hoverPopup) { this.hoverPopup.remove(); this.hoverPopup = null; }
      this.closeSticky();
      var self = this;
      var pop = new ml.Popup({ offset: POP_OFFSET, closeButton: true, closeOnClick: true, maxWidth: '280px', className: 'bpmsl-popup' })
        .setLngLat([s.lng, s.lat]).setDOMContent(this.popupNode(s, true)).addTo(this.map);
      pop.on('close', function () {
        if (pop._bpmSilent) return;
        if (self.stickyPopup === pop) self.stickyPopup = null;
        if (self.selectedId === id) self.deselect();
      });
      this.stickyPopup = pop;
    } else {
      if (this.hoverPopup) this.hoverPopup.remove();
      this.hoverPopup = new ml.Popup({ offset: POP_OFFSET, closeButton: false, closeOnClick: false, maxWidth: '260px', className: 'bpmsl-popup bpmsl-popup--hover' })
        .setLngLat([s.lng, s.lat]).setDOMContent(this.popupNode(s, false)).addTo(this.map);
    }
  };

  // close the pinned popup without triggering a deselect
  Locator.prototype.closeSticky = function () {
    if (!this.stickyPopup) return;
    var p = this.stickyPopup;
    this.stickyPopup = null;
    p._bpmSilent = true;
    p.remove();
  };

  Locator.prototype.deselect = function () {
    var id = this.selectedId;
    if (!id) return;
    this.selectedId = null;
    var li = this.items[id];
    if (li) {
      li.classList.remove('is-selected');
      var g = li.querySelector('[data-google-embed]');
      if (g) g.hidden = true;
    }
    var btn = this.pinBtn(id);
    if (btn) btn.classList.remove('is-selected');
  };

  Locator.prototype.select = function (id, opts) {
    opts = opts || {};
    var s = this.byId[id];
    if (!s) return;
    if (this.selectedId && this.selectedId !== id) {
      this.closeSticky();
      this.deselect();
    }
    this.selectedId = id;

    var li = this.items[id];
    if (li) {
      li.classList.add('is-selected');
      var g = li.querySelector('[data-google-embed]');
      if (g) {
        if (!g.firstChild) {
          var f = document.createElement('iframe');
          f.src = g.getAttribute('data-src');
          f.title = g.getAttribute('data-title') || 'Google listing';
          f.loading = 'lazy';
          f.referrerPolicy = 'no-referrer-when-downgrade';
          f.setAttribute('allowfullscreen', '');
          g.appendChild(f);
        }
        g.hidden = false;
      }
    }
    var btn = this.pinBtn(id);
    if (btn) btn.classList.add('is-selected');

    if (this.map && s.hasPin) {
      if (opts.fly) {
        var z = Math.max(this.map.getZoom(), 14);
        if (reduceMotion) this.map.jumpTo({ center: [s.lng, s.lat], zoom: z });
        else this.map.flyTo({ center: [s.lng, s.lat], zoom: z, speed: 1.6, maxDuration: 2500 });
        if (this.isStacked()) {
          var r = this.mapEl.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) this.mapEl.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          this.scrollToItem(id, false);
        }
      }
      if (opts.popup) this.showPopup(id, true);
    }
    if (opts.scrollList && !this.isStacked()) this.scrollToItem(id, false);
  };

  // true when the list sits under the map (phones and small tablets)
  Locator.prototype.isStacked = function () {
    if (!this.panel || !this.mapEl) return false;
    return Math.abs(this.panel.getBoundingClientRect().left - this.mapEl.getBoundingClientRect().left) < 2;
  };

  Locator.prototype.scrollToItem = function (id, force) {
    var li = this.items[id];
    if (!li || li.hidden) return;
    var p = this.panel;
    var scrollable = p && p.scrollHeight > p.clientHeight + 2 && getComputedStyle(p).overflowY !== 'visible';
    if (scrollable) {
      var head = this.statusEl ? this.statusEl.parentNode.offsetHeight : 0;
      var top = li.offsetTop - head - 8;
      p.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    } else if (force) {
      li.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  /* ---------- view helpers ---------- */
  Locator.prototype.fitStores = function (list, maxZoom, instant, extraPoint) {
    if (!this.map) return;
    var pts = list.map(function (s) { return [s.lng, s.lat]; });
    if (extraPoint) pts.push([extraPoint.lng, extraPoint.lat]);
    var dur = instant || reduceMotion ? 0 : 700;
    if (!pts.length) {
      this.map.jumpTo({ center: [-96, 58], zoom: 2.6 });
      return;
    }
    if (pts.length === 1) {
      this.map.easeTo({ center: pts[0], zoom: Math.min(maxZoom || 12, 13), duration: dur });
      return;
    }
    var b = new window.maplibregl.LngLatBounds(pts[0], pts[0]);
    for (var i = 1; i < pts.length; i++) b.extend(pts[i]);
    var w = this.mapEl.clientWidth;
    var pad = Math.max(30, Math.min(70, w * 0.08));
    this.map.fitBounds(b, { padding: pad, maxZoom: maxZoom || 12, duration: dur });
  };

  Locator.prototype.showAll = function () {
    this.clearOrigin();
    if (this.provSelect) this.provSelect.value = '';
    if (this.qInput) this.qInput.value = '';
    this.closeSticky();
    this.deselect();
    if (this.map) this.fitStores(this.pinStores, 12);
    this.refreshList();
  };

  Locator.prototype.clearOrigin = function () {
    this.origin = null;
    this.originLabel = '';
    if (this.originMarker) { this.originMarker.remove(); this.originMarker = null; }
  };

  Locator.prototype.setOrigin = function (pt, label) {
    this.closeSticky();
    this.deselect();
    this.origin = { lat: pt.lat, lng: pt.lng };
    this.originLabel = label;
    if (this.provSelect) this.provSelect.value = '';
    var self = this;
    var sorted = this.pinStores.slice().sort(function (a, b) { return km(self.origin, a) - km(self.origin, b); });
    if (this.map) {
      if (this.originMarker) this.originMarker.remove();
      var n = el('div', 'bpmsl-note');
      n.innerHTML = NOTE_SVG;
      n.setAttribute('title', label);
      this.originMarker = new window.maplibregl.Marker({ element: n, anchor: 'center' }).setLngLat([pt.lng, pt.lat]).addTo(this.map);
      var near = sorted.filter(function (s) { return km(self.origin, s) <= 25; });
      if (near.length < 3) near = sorted.slice(0, Math.min(3, sorted.length));
      this.fitStores(near, 13, false, this.origin);
    }
    this.refreshList();
  };

  Locator.prototype.status = function (msg) {
    if (this.statusEl) this.statusEl.textContent = msg;
  };

  /* ---------- search ---------- */
  Locator.prototype.search = function (q) {
    var self = this;
    q = String(q || '').trim();
    if (!q) { this.showAll(); return; }
    var compact = q.toUpperCase().replace(/[\s-]+/g, '');

    // Postal code (full or first 3 characters)
    if (/^[ABCEGHJKLMNPRSTVXY]\d[A-Z](\d[A-Z]\d)?$/.test(compact)) {
      this.status('Searching…');
      loadFsa(this.fsaUrl).then(function (map) {
        var pt = map[compact.slice(0, 3)];
        if (pt) self.setOrigin(pt, compact.length === 6 ? compact.slice(0, 3) + ' ' + compact.slice(3) : compact);
        else self.notFound(q);
      }).catch(function () { self.notFound(q); });
      return;
    }

    var nq = norm(q);

    // Province name or abbreviation
    var provName = PROVINCES[q.toUpperCase().replace(/\./g, '')] || null;
    if (!provName) {
      for (var k in PROVINCES) { if (norm(PROVINCES[k]) === nq) { provName = PROVINCES[k]; break; } }
    }
    if (provName) {
      this.clearOrigin();
      var inProv = this.pinStores.filter(function (s) { return s.prov === provName; });
      if (inProv.length) {
        if (this.provSelect) this.provSelect.value = provName;
        this.fitStores(inProv, 11);
        this.refreshList();
        return;
      }
    }

    // A city where we already have stores
    var cityPart = norm(q.split(',')[0]);
    var inCity = this.pinStores.filter(function (s) { return norm(s.city) === cityPart; });
    if (inCity.length) {
      var lat = 0, lng = 0;
      inCity.forEach(function (s) { lat += s.lat; lng += s.lng; });
      this.setOrigin({ lat: lat / inCity.length, lng: lng / inCity.length }, q);
      return;
    }

    // Anything else: free OpenStreetMap geocoder (one request per search)
    this.status('Searching…');
    var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=ca&accept-language=en&q=' + encodeURIComponent(q);
    fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('geocoder ' + r.status);
      return r.json();
    }).then(function (res) {
      if (res && res[0]) self.setOrigin({ lat: parseFloat(res[0].lat), lng: parseFloat(res[0].lon) }, q);
      else self.notFound(q);
    }).catch(function () { self.notFound(q); });
  };

  Locator.prototype.notFound = function (q) {
    this.refreshList();
    this.status('We could not find “' + q + '”. Try a postal code like M4E 1E3.');
  };

  Locator.prototype.nearMe = function () {
    var self = this;
    if (!navigator.geolocation) return;
    this.status('Finding your location…');
    navigator.geolocation.getCurrentPosition(function (pos) {
      if (self.qInput) self.qInput.value = '';
      self.setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude }, 'your location');
    }, function () {
      self.refreshList();
      self.status('Location is off. Search by postal code instead.');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
  };

  /* ---------- list ---------- */
  Locator.prototype.refreshList = function () {
    var self = this;
    var bounds = this.map ? this.map.getBounds() : null;
    var total = this.stores.length;
    var visible = 0;

    var dist = {};
    if (this.origin) {
      this.stores.forEach(function (s) { if (s.hasPin) dist[s.id] = km(self.origin, s); });
    }

    var pinsInView = 0;
    if (bounds) this.pinStores.forEach(function (s) { if (bounds.contains([s.lng, s.lat])) pinsInView++; });
    var wholeView = !bounds || (!this.origin && pinsInView === this.pinStores.length);

    this.stores.forEach(function (s) {
      var li = self.items[s.id];
      if (!li) return;
      var inView = s.hasPin ? (!bounds || bounds.contains([s.lng, s.lat])) : wholeView;
      li.hidden = !inView;
      if (inView) visible++;
      var d = li.querySelector('[data-dist]');
      if (d) {
        if (self.origin && dist[s.id] != null) { d.textContent = fmtKm(dist[s.id]); d.hidden = false; }
        else d.hidden = true;
      }
    });

    // order: by distance when searching, else province and city groups
    var ordered = null;
    if (this.origin) {
      ordered = this.stores.filter(function (s) { return dist[s.id] != null; })
        .sort(function (a, b) { return dist[a.id] - dist[b.id]; });
      ordered.forEach(function (s, i) { var li = self.items[s.id]; if (li) li.style.order = String(i + 1); });
      this.stores.forEach(function (s) { if (dist[s.id] == null && self.items[s.id]) self.items[s.id].style.order = '9999'; });
    } else {
      this.stores.forEach(function (s) { if (self.items[s.id]) self.items[s.id].style.order = ''; });
    }

    // group headings: show only when a store below them is visible
    var kids = this.listEl.children, curProv = null, curCity = null;
    for (var i = 0; i < kids.length; i++) {
      var c = kids[i], h = c.getAttribute('data-heading');
      if (h === 'prov') { curProv = c; c.hidden = true; }
      else if (h === 'city') { curCity = c; c.hidden = true; }
      else if (!c.hidden && !this.origin) {
        if (curProv) curProv.hidden = false;
        if (curCity) curCity.hidden = false;
      }
    }
    this.root.classList.toggle('bpmsl--searching', !!this.origin);

    if (this.emptyEl) this.emptyEl.hidden = visible > 0;

    var filtered = visible < total;
    var msg;
    if (this.origin) {
      var nearest = ordered && ordered[0];
      if (nearest && dist[nearest.id] > 100) {
        msg = 'Nearest store to ' + this.originLabel + ' is ' + fmtKm(dist[nearest.id]) + ' away.';
      } else {
        msg = 'Stores nearest to ' + this.originLabel;
      }
    } else if (!filtered) {
      msg = total + (total === 1 ? ' store' : ' stores');
    } else {
      msg = visible + ' of ' + total + ' stores in this map area';
    }
    this.status(msg);
    var showReset = filtered || !!this.origin || (this.provSelect && this.provSelect.value);
    if (this.showAllBtns[0]) this.showAllBtns[0].hidden = !showReset;
  };

  Locator.prototype.destroy = function () {
    if (this.map) { this.map.remove(); this.map = null; }
  };

  /* ---------- boot ---------- */
  var instances = [];
  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-bpmsl]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i]._bpmsl) continue;
      roots[i]._bpmsl = new Locator(roots[i]);
      instances.push(roots[i]._bpmsl);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-bpmsl]');
    if (r && r._bpmsl) { r._bpmsl.destroy(); r._bpmsl = null; }
  });

  window.BPMStoreLocator = { boot: boot, instances: instances };
})();